import ApiHandler from '@/api/base'

class IntervalsInfoApiHandler extends ApiHandler {
  async getIntervalsInfo({ workspaceId }) {
    const { data } = await this.http.post('/getIntervalInfo', { workspaceId })
    return data
  }

  async getAllIntervalsInfo({ workspaceId }) {
    const { data } = await this.http.post('/getAllIntervals', { workspaceId })
    return data
  }

  /**
   * `typeId`: `0` all current (not a quarter and not a year), `1` quarter, `2` year. see ACTIVE_INTERVAL_TYPE_IDS in src/core/utils/interval.js
   *
   * @returns {Promise<{
   *   intervals: Array<{
   *     id: number,
   *     workspaceId: number,
   *     typeId: 0 | 1 | 2,
   *     startDate: string,
   *     endDate: string
   *   }>
   * }>}
   */
  async getAllActiveIntervals() {
    const { data } = await this.http.get('/getAllActiveIntervals')
    return data
  }

  async createInterval(payload) {
    const { data } = await this.http.post('/createInterval', payload)
    return data
  }

  async updateInterval(payload) {
    const { data } = await this.http.post('/updateInterval', payload)
    return data
  }

  async removeInterval({ id = null, workspaceId }) {
    const { data } = await this.http.post('/removeInterval', {
      id,
      workspaceId
    })
    return data
  }
}

export default IntervalsInfoApiHandler
